const actions = {
  UPDATE_SEGMENTS({ commit }, payload) {
    commit("SET_SEGMENTS", payload)
  },
  UPDATE_SMS_TEMPLATES({ commit }, payload) {
    commit("SET_SMS_TEMPLATES", payload)
  },
  UPDATE_EMAIL_TEMPLATES({ commit }, payload) {
    commit("SET_EMAIL_TEMPLATES", payload)
  },
  UPDATE_ANNOUNCEMENTS({ commit }, payload) {
    commit("SET_ANNOUNCEMENTS", payload)
  },
}

export default actions
